import { Box } from '@machobear/design-system'

import BaseLayout from '@/features/Settings/Layout/base-layout'
import { BoxStyle } from '../index.css'

type Props = {
  children: React.ReactNode
  title: string
}

const AutoReplyPageWrapper = ({ children, title }: Props) => {
  return (
    <BaseLayout title={title}>
      <Box
        paddingY={{ mobile: 'gutter', desktop: 'xlarge' }}
        paddingX={{ mobile: 'gutter', desktop: 'xxxlarge' }}
        display="flex"
        flexDirection="column"
        gap="gutter"
        width="full"
      >
        <Box className={BoxStyle} display="flex" flexDirection="column" gap="gutter">
          {children}
        </Box>
      </Box>
    </BaseLayout>
  )
}

export default AutoReplyPageWrapper
